<template>
  <div v-if="!!identityProvider">
    <identity-provider-form
      :errors="errors"
      :model="identity_provider"
      :title="`Edit ${identityProvider.name} Identity Provider`"
      action="updateIdentityProvider"
      @updateIdentityProvider="updateIdentityProvider"
    />
  </div>
</template>

<script>
import IdentityProviderForm from './Form';
import { mapState } from 'vuex';
import { closeModal, showToast } from '@inscribe/signal';
import { formatXhrErrorMessage } from '@/utils/xhrErrors';

export default {
  components: {
    'identity-provider-form': IdentityProviderForm,
  },
  data() {
    return {
      identity_provider: {},
      errors: [],
    };
  },
  computed: {
    ...mapState(['identityProvider']),
  },
  watch: {
    '$route.params.identity_provider_id': {
      immediate: true,
      handler: function (newIdentityProviderId, oldIdentityProviderId) {
        this.$store.commit(
          'setSelectedIdentityProviderId',
          this.$route.params.identity_provider_id,
        );
      },
    },
    identityProvider: {
      immediate: true,
      handler: function (newSelectecIdP, oldSelectedIdP) {
        if (this.identityProvider) {
          const copiedIdP = JSON.parse(JSON.stringify(this.identityProvider));
          this.$set(this, 'identity_provider', copiedIdP);
          this.$set(this, 'hasLoadedIdentityProvider', true);
        }
      },
    },
  },
  mount() {
    this.$store.dispatch('getIdentityProvider');
  },
  methods: {
    updateIdentityProvider(identityProviderData) {
      this.$store
        .dispatch('updateIdentityProvider', { ...identityProviderData })
        .then(
          (response) => {
            this.$store.commit('setIdentityProvider', response.data);
            showToast({
              text: 'Identity Provider successfully updated.',
            });
            this.$router.push({ name: 'saml-settings-view' });
            closeModal('saml-modal');
          },
          (error) => {
            const errorMessage = formatXhrErrorMessage({
              errorPrefix: 'Error updating identity provider',
              error,
            });
            this.errors = [{ message: errorMessage }];
          },
        );
    },
  },
};
</script>
